import { LanguageSplitter } from "@physiofit-digital/physiofit_types";
import { getLanguage } from "../store/appSlice";
import { useMainStore } from "../store/mainStore";

export type Language =
  | "de"
  | "en"
  | "tr"
  | "cs"
  | "ru"
  | "hr"
  | "es"
  | "fr"
  | "it"
  | "sq";

export const useLanguageSplitter = () => {
  let language = useMainStore(getLanguage) as Language | undefined;

  const validLanguages: Language[] = [
    "de",
    "en",
    "tr",
    "cs",
    "ru",
    "hr",
    "es",
    "fr",
    "it",
    "sq",
  ];

  if (!language || !validLanguages.includes(language)) {
    language = "de";
  }
  return (
    textObject:
      | LanguageSplitter
      | Partial<Record<Language, string>>
      | undefined,
  ) => languageSplitter(textObject, language as Language);
};

const languageSplitter = (
  textObject: LanguageSplitter | Partial<Record<Language, string>> | undefined,
  lang: Language,
) => {
  if (!textObject) {
    return "";
  }

  // @ts-ignore
  return textObject[lang] ?? (textObject.de || "");
};
